import React, { useState, useEffect } from "react";
import { checkResult, createSelectOption } from "@/common";
import { useWatchState } from "@/store";
import { BaseService } from "@/service";
import { Modal, Card, message, Divider, Button, Icon, Collapse, Form, Col, Row, Input, Select } from "antd";
import moment from "moment";

const { Panel } = Collapse;
const NAME = "projectUpdateRec";

const App = Form.create({ name: 'register' })((props) => {
    const { getFieldDecorator } = props.form;

    const [loading, setLoading] = useState(false);
    const [[IS_REGION], [{ IS_LOGIN, info }]] = useWatchState(["IS_REGION", "user",]);
    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME])
    const { title = "", show, hide, width = 1000, DetailId, expertId, orgId,contrast, callback } = modalProps;
    const [data, setData] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const { Option, OptGroup } = Select;
    const InputGroup = Input.Group;
    const { TextArea } = Input;

    const formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 },
    };


    useEffect(() => {
        if (DetailId) {
            projectShow(DetailId);
            projectRecShow(DetailId)
        }
    }, [DetailId])

    const projectShow = (DetailId) => {
        BaseService.list({
            table: "thtt_project",
            columns: "id,name,org_name,orgRec_id,personRec_id",
            where: {
                "id": DetailId,
                "is_delete": 0,
            },
        }).then(res => {
            if (!checkResult(res)) return;
            setProjectData(res.data.result[0]);
        })
    }

    const projectRecShow = (DetailId) => {
        BaseService.list({
            table: "thtt_project_rec_opinion",
            where: {
                "project_id": DetailId,
                "is_delete": 0,
                ...((orgId) ? { roc_org: projectData.orgRec_id } : (expertId ? { roc_org: projectData.personRec_id } : ''))
            },
        }).then(res => {
            if (!checkResult(res)) return;
            setData(res.data.result[0]);
        })
    }


    const onSubmit = async (e) => {
        e.preventDefault();
        const update_date = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');

        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                setLoading(true); const res = await BaseService.put({
                    table: "thtt_project_rec_opinion", data: {
                        original: values.original,
                        innovate: values.innovate,
                        core: values.core,
                        tradition: values.tradition,
                        develop: values.develop,
                        strategy: values.strategy,
                        realize: values.realize,
                        market: values.market,
                        profit: values.profit,
                        target_market: values.target_market,
                        promote: values.promote,
                        life_cycle: values.life_cycle,
                        investment_heat: values.investment_heat,
                        team_operations: values.team_operations,
                        implementation_risk: values.implementation_risk,
                        generality: values.generality,
                        resources: values.resources,
                        prepare: values.prepare,
                        comment: values.comment,
                        recommend_type: values.recommend_type,
                        update_date: update_date
                    }, where: { project_id: data.project_id }
                }).then(res=>{
                    if (!checkResult(res)) return;
                    BaseService.put({
                        table: "thtt_project", data: {
                            report_type:values.recommend_type,
                            recommend_date: update_date,
                        },where: { id: data.project_id }
                    })
                });

                setLoading(false);

                message.success("修改成功！");
                hide();
                if (callback) callback();
            }
        });
    }

    return (
        <Modal
            visible={show}
            width={width}
            maskClosable={false}
            destroyOnClose
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={onSubmit}>
                <Collapse defaultActiveKey={['1']}>
                    <Panel header="修改已入围项目推荐意见" key="1">
                        <div style={{ textAlign: "center" }}>
                            <h3 style={{ textAlign: "center" }}>中华国际科技交流基金会</h3>
                            <h3 style={{ textAlign: "center" }}>科技成果转化项目双推双促工程</h3>
                            <h3 style={{ textAlign: "center" }}>入围项目推荐意见书</h3>
                        </div>
                        <Row gutter={24} type="flex" style={{ marginTop: 20, height: 30 }}>
                            <div style={{ textAlign: "left", marginLeft: 10, display: "inline-block" }}>申报项目名称：{projectData.name}</div>
                            <div style={{ textAlign: "right", float: "right", marginLeft: 50 }}>申报单位：{projectData.org_name}</div>
                        </Row>

                        <Row gutter={24} type="flex">
                            <Card title="高技术价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                                <Col span={8} >
                                    <Form.Item label="自主原创重大技术成果" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('original', {
                                            initialValue: String(data["original"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="前沿引领创新技术成果" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('innovate', {
                                            initialValue: String(data["innovate"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="产业关键核心技术成果" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('core', {
                                            initialValue: String(data["core"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </Col>
                            </Card>
                        </Row>
                        <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                            <Card title="高产业价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                                <Col span={8} >
                                    <Form.Item label="助力传统产业转型升级" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('tradition', {
                                            initialValue: String(data["tradition"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col span={8} >
                                    <Form.Item label="支撑战略新兴产业发展" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('develop', {
                                            initialValue: String(data["develop"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="发挥未来产业定位方向" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('strategy', {
                                            initialValue: String(data["strategy"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Card>
                        </Row>
                        <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                            <Card title="高经济价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                                <Col span={8} >
                                    <Form.Item label="项目已实现营收规模大" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('realize', {
                                            initialValue: String(data["realize"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col span={8} >
                                    <Form.Item label="项目对地区经济贡献大" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('market', {
                                            initialValue: String(data["market"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="项目可实现效益预期大" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('profit', {
                                            initialValue: String(data["profit"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Card>
                        </Row>
                        <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                            <Card title="高市场价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                                <Col span={8} >
                                    <Form.Item label="成果目标市场规模巨大" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('target_market', {
                                            initialValue: String(data["target_market"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col span={8} >
                                    <Form.Item label="成果推广应用场景多元" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('promote', {
                                            initialValue: String(data["promote"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="成果市场生命周期可见" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('life_cycle', {
                                            initialValue: String(data["life_cycle"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Card>
                        </Row>
                        <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                            <Card title="高资本价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                                <Col span={8} >
                                    <Form.Item label="项目方向投资热度较高" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('investment_heat', {
                                            initialValue: String(data["investment_heat"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col span={8} >
                                    <Form.Item label="项目团队运作能力较强" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('team_operations', {
                                            initialValue: String(data["team_operations"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="项目实施风险防控可信" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('implementation_risk', {
                                            initialValue: String(data["implementation_risk"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Card>
                        </Row>
                        <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                            <Card title="高转化价值" style={{ width: 960, height: 140, marginLeft: 10 }}>
                                <Col span={8} >
                                    <Form.Item label="主体企业创新能力到位" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('generality', {
                                            initialValue: String(data["generality"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>

                                </Col>
                                <Col span={8} >
                                    <Form.Item label="成果转化资源要素到位" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('resources', {
                                            initialValue: String(data["resources"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={8} >
                                    <Form.Item label="成果转化落地进程到位" type="flex" style={{ width: 900 }}>
                                        {getFieldDecorator('prepare', {
                                            initialValue: String(data["prepare"]) || undefined
                                        })(
                                            <Select style={{ width: "100px" }}>
                                                {createSelectOption([
                                                    { label: "请选择", value: "0" },
                                                    { label: "符合", value: "1" },
                                                    { label: "一般", value: "2" },
                                                ])}
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Card>
                        </Row>
                        <Divider>项目推荐意见</Divider>
                        <Row gutter={24} type="flex" style={{ marginTop: 20 }}>
                            <Col span={7} >
                                <Form.Item label="*项目推荐意见" type="flex" style={{ width: 600 }}>
                                    {getFieldDecorator('recommend_type', {
                                        initialValue: String(data["recommend_type"]) || undefined
                                    })(
                                        <Select placeholder="请选择项目推荐意见" style={{ width: "150px" }}>
                                            {createSelectOption([
                                                { label: "领航项目", value: "1" },
                                                { label: "启航项目", value: "2" },
                                                { label: "备航项目", value: "3" },
                                            ])}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={17} >
                                <Form.Item label="项目简要评语" type="flex" style={{ width: 650 }}>
                                    {getFieldDecorator('comment', {
                                        initialValue: data.comment,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入项目简要评语',
                                            },
                                        ],
                                    })(<Input.TextArea cols={450} rows={4} placeholder="项目核心技术（所属产业领域/核心主打产品/主要业务模式/整体营销规模/所在行业单位）/项目应用场景" />)}
                                </Form.Item></Col>

                        </Row>
                        <div className="flex hor child-left-xl m-md-t">
                            <Button type="primary" onClick={onSubmit} loading={loading}>修改</Button>
                            <Button onClick={hide} >取消</Button>
                        </div>
                    </Panel>
                </Collapse>
            </Form>
        </Modal>
    );
})

export default App;